<eui-dropdown width="340px">
    <div class="eui-user-profile-content">
        <div class="eui-user-profile__infos" [class.eui-user-profile__infos--no-subinfos]="!(asServie.state$ | async)?.userSubInfos && !hasWelcomeLabel">
            <ng-template [ngIf]="!(asServie.state$ | async)?.impersonatedUserInfos">
                <div class="eui-user-profile__infos-container">
                    <div class="eui-user-profile__infos-welcome">
                        <span *ngIf="hasWelcomeLabel">{{welcomeLabel}}&nbsp;</span>
                        <span class="eui-user-profile__infos-name">{{(asServie.state$ | async)?.userInfos}}</span>
                    </div>
                </div>
                <div *ngIf="(asServie.state$ | async)?.userSubInfos" class="eui-user-profile__infos-subinfos">
                    {{(asServie.state$ | async)?.userSubInfos}}
                </div>
            </ng-template>

            <ng-template [ngIf]="(asServie.state$ | async)?.impersonatedUserInfos">
                <div class="eui-user-profile__infos-container">
                    <div class="eui-user-profile__infos-welcome">
                        <span *ngIf="hasWelcomeLabel">{{welcomeLabel}}&nbsp;</span>
                        <strong>{{(asServie.state$ | async)?.userInfos}}</strong>
                        &nbsp;{{impersonateLabel}}
                    </div>
                </div>
                <span class="eui-user-profile__infos-name">{{(asServie.state$ | async)?.impersonatedUserInfos}}</span>
                <div *ngIf="(asServie.state$ | async)?.userSubInfos" class="eui-user-profile__infos-subinfos">
                    {{(asServie.state$ | async)?.userSubInfos}}
                </div>
            </ng-template>
        </div>

        <div *ngIf="(asServie.state$ | async)?.impersonatedUserInfos" class="eui-user-profile__avatar-shadow">
            <div class="eui-user-profile__avatar eui-u-svg eui-u-svg--default-avatar"></div>
        </div>
        <div *ngIf="!avatarUrl" class="eui-user-profile__avatar" [ngClass]="isOnline ? 'eui-user-profile__avatar--online' : 'eui-user-profile__avatar--offline'">
        </div>
        <div *ngIf="avatarUrl" class="eui-user-profile__avatar eui-u-svg">
            <img [src]="avatarUrl" alt="avatar"/>
        </div>
    </div>

    <eui-dropdown-content>
        <ng-content></ng-content>
    </eui-dropdown-content>
</eui-dropdown>
